/**
 * Owner-admin API client for Money > Payouts (freelancer pay).
 * All under /api/admin/v2/payouts/, IsSuperuser-gated server-side.
 * Amounts go up in rupees and come back in paise.
 */
import api from "./axios";

const BASE = "/api/admin/v2/payouts";

export const getPayoutOverview = () => api.get(`${BASE}/overview/`);

export const listFreelancers = () => api.get(`${BASE}/freelancers/`);
export const createFreelancer = (body) => api.post(`${BASE}/freelancers/`, body);
export const updateFreelancer = (id, body) => api.patch(`${BASE}/freelancers/${id}/`, body);
export const verifyFreelancer = (id) => api.post(`${BASE}/freelancers/${id}/verify/`);

export const listWorkItems = (params = {}) => api.get(`${BASE}/work/`, { params });
export const addManualWorkItem = (body) => api.post(`${BASE}/work/`, body);
export const syncWorkItems = () => api.post(`${BASE}/work/sync/`);
export const reviewWorkItems = ({ ids, action, note, amount }) =>
  api.post(`${BASE}/work/review/`, { ids, action, note, amount });

export const listPayRuns = () => api.get(`${BASE}/runs/`);
export const buildPayRun = (weekStart) => api.post(`${BASE}/runs/`, { week_start: weekStart });
export const getPayRun = (id) => api.get(`${BASE}/runs/${id}/`);
// confirm_total_paise must equal the server's total, so a stale page can't pay.
export const payRun = (id, confirmTotalPaise) =>
  api.post(`${BASE}/runs/${id}/pay/`, { confirm_total_paise: confirmTotalPaise });
export const refreshPayRun = (id) => api.post(`${BASE}/runs/${id}/refresh/`);
export const exportPayRun = (id) =>
  api.get(`${BASE}/runs/${id}/export/`, { responseType: "blob" });

export const updatePayLine = (id, body) => api.patch(`${BASE}/lines/${id}/`, body);
export const payLineAction = (id, action) => api.post(`${BASE}/lines/${id}/${action}/`);
